import React, { useEffect, useState } from "react";
import { Getdata } from "../../helpers/api.service";

const Performance = () => {
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
      `/front/education/performance/fetch/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {data.length > 0 &&
        data.map((item, index) => (
          <div className="bg-[#F9F5FF] border-[1px]  rounded-lg p-6 relative text-gray-800   mx-auto text-start mb-3">
            <div>
              <h2 className="text-2xl font-bold mb-2">
                Academic Performance Report
              </h2>

              <div className="text-sm mb-4">
                <span className="mr-4">
                  Performance Year:{" "}
                  <span className="font-medium ">{item.year}</span>
                </span>
                <span className="mr-4">
                  Total Number of Candidates:{" "}
                  <span className="font-medium">{item.no_of_candidates}</span>
                </span>
                <span>
                  Mean Grade:{" "}
                  <span className="font-medium">{item.mean_grade}</span>
                </span>
              </div>

              <div className="mb-4">
                <h3 className="font-bold mb-1 text-[15px]">Performance Summary</h3>
                <p className="text-sm leading-relaxed">
                  {item.summary
                    ? item.summary
                    : "No summary available for this performance report."}
                </p>
              </div>

              <div>
                <h3 className="font-bold mb-1 text-[15px]">
                  Performance Narrative
                </h3>

                <div dangerouslySetInnerHTML={{ __html: item.narrative }} />
              </div>
            </div>
          </div>
        ))}

      {data?.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default Performance;
